import { ConsentTypeEnumType } from "@libs/api/patients";
import { HTTPStatusCode } from "@libs/api/types";
import { sendSentryError } from "@/services/sentry";
import { tsRestClient } from "@/services/ts-rest";

export const ConsentsApi = {
  getPendingConsents: async () => {
    const res = await tsRestClient().consents.getPendingConsents();

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      message: "Unexpected response in ConsentsApi.getPendingConsents",
      error: res.body,
      shouldThrowError: true,
    });
  },
  createPatientConsent: async ({
    consentType,
    isConsented,
  }: {
    consentType: ConsentTypeEnumType;
    isConsented: boolean;
  }) => {
    const res = await tsRestClient().consents.createPatientConsent({
      body: { consentType, isConsented },
    });

    if (res.status === HTTPStatusCode.CREATED) {
      return res.body;
    }

    sendSentryError({
      message: "Unexpected response in ConsentsApi.createPatientConsent",
      error: res.body,
      shouldThrowError: true,
    });
  },
};
